// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login-root-NZFXR {
	padding-left: 20px;
	padding-right: 20px;
}

.Login-container-R_KwO {
	margin: 0 auto;
	padding: 30px 0 40px;
	max-width: 380px;
}

.Login-lineThrough-cDevd {
	font-size: 14px;
	line-height: 18px;
	font-weight: 500;
	text-align: center;
	position: relative;
	margin: 20px 0;
}

.Login-linkText-pnai8 {
	font-size: 14px;
	line-height: 18px;
	font-weight: 500;
	display: grid;
	grid-template-columns: auto auto;
	grid-gap: 6px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-bottom: 0px;
	margin-top: 20px;
}

.Login-linetext-QsBjG {
	position: relative;
	display: inline-block;
}

.Login-linetext-QsBjG::before {
	content: '';
	position: absolute;
	top: 9px;
	left: -30px;
	width: 26px;
	height: 1px;
	background-color: var(--primary-foreground);
}

.Login-linetext-QsBjG::after {
	content: '';
	position: absolute;
	top: 9px;
	right: -30px;
	width: 26px;
	height: 1px;
	background-color: var(--primary-foreground);
}

.Login-horizontalLineThrough-Tck1l {
	position: relative;
	z-index: 1;
	display: block;
	margin: 15px 0px;
	width: 100%;
	color: var(--primary-border);
	text-align: center;
	font-size: 14px;
}

.Login-formGroup-wI0Mm {
	margin-bottom: 6px;
}

.Login-formSection-fwd4B {
	overflow: hidden;
}

.Login-noPadding-Jz1YD {
	padding: 0px;
}

.Login-textAlignRight-qpbQ_ {
	text-align: right;
}

.Login-textAlignCenter-pDyEX {
	text-align: center;
}

.Login-textAlignLeft-crcAR {
	text-align: left;
}

.Login-modalCaptionLink-nunWO,
.Login-modalCaptionLink-nunWO:hover,
.Login-modalCaptionLink-nunWO:focus,
.Login-modalCaptionLink-nunWO:active {
	color: var(--primary-link-foreground);
	font-size: 14px;
	text-decoration: underline;
	cursor: pointer;
}

.Login-button-zeygg {
	display: block;
	border-radius: 4px;
	text-decoration: none !important;
}

.Login-loginHeading-Wq4C6 {
	font-size: 18px;
	text-align: center;
	margin: 0 0 22px;
}

@media screen and (max-width: 1200px) {
	.Login-container-R_KwO {
		margin: 0 auto;
		padding: 100px 0 40px;
		max-width: 380px;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/login/Login.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,aAAa;CACb,gCAAgC;CAChC,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,WAAW;CACX,WAAW;CACX,2CAA2C;AAC5C;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,WAAW;CACX,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,4BAA4B;CAC5B,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;CAIC,qCAAqC;CACrC,eAAe;CACf,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC;EACC,cAAc;EACd,qBAAqB;EACrB,gBAAgB;CACjB;AACD","sourcesContent":[".root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 30px 0 40px;\n\tmax-width: 380px;\n}\n\n.lineThrough {\n\tfont-size: 14px;\n\tline-height: 18px;\n\tfont-weight: 500;\n\ttext-align: center;\n\tposition: relative;\n\tmargin: 20px 0;\n}\n\n.linkText {\n\tfont-size: 14px;\n\tline-height: 18px;\n\tfont-weight: 500;\n\tdisplay: grid;\n\tgrid-template-columns: auto auto;\n\tgrid-gap: 6px;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-bottom: 0px;\n\tmargin-top: 20px;\n}\n\n.linetext {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.linetext::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 9px;\n\tleft: -30px;\n\twidth: 26px;\n\theight: 1px;\n\tbackground-color: var(--primary-foreground);\n}\n\n.linetext::after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 9px;\n\tright: -30px;\n\twidth: 26px;\n\theight: 1px;\n\tbackground-color: var(--primary-foreground);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: block;\n\tmargin: 15px 0px;\n\twidth: 100%;\n\tcolor: var(--primary-border);\n\ttext-align: center;\n\tfont-size: 14px;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.formSection {\n\toverflow: hidden;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.textAlignRight {\n\ttext-align: right;\n}\n\n.textAlignCenter {\n\ttext-align: center;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.modalCaptionLink,\n.modalCaptionLink:hover,\n.modalCaptionLink:focus,\n.modalCaptionLink:active {\n\tcolor: var(--primary-link-foreground);\n\tfont-size: 14px;\n\ttext-decoration: underline;\n\tcursor: pointer;\n}\n\n.button {\n\tdisplay: block;\n\tborder-radius: 4px;\n\ttext-decoration: none !important;\n}\n\n.loginHeading {\n\tfont-size: 18px;\n\ttext-align: center;\n\tmargin: 0 0 22px;\n}\n\n@media screen and (max-width: 1200px) {\n\t.container {\n\t\tmargin: 0 auto;\n\t\tpadding: 100px 0 40px;\n\t\tmax-width: 380px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Login-root-NZFXR`,
	"container": `Login-container-R_KwO`,
	"lineThrough": `Login-lineThrough-cDevd`,
	"linkText": `Login-linkText-pnai8`,
	"linetext": `Login-linetext-QsBjG`,
	"horizontalLineThrough": `Login-horizontalLineThrough-Tck1l`,
	"formGroup": `Login-formGroup-wI0Mm`,
	"formSection": `Login-formSection-fwd4B`,
	"noPadding": `Login-noPadding-Jz1YD`,
	"textAlignRight": `Login-textAlignRight-qpbQ_`,
	"textAlignCenter": `Login-textAlignCenter-pDyEX`,
	"textAlignLeft": `Login-textAlignLeft-crcAR`,
	"modalCaptionLink": `Login-modalCaptionLink-nunWO`,
	"button": `Login-button-zeygg`,
	"loginHeading": `Login-loginHeading-Wq4C6`
};
module.exports = ___CSS_LOADER_EXPORT___;
